import React, {useEffect, useState} from "react";

import styles from "./Analysis.module.css";

const Analysis = (props) => {
  const [key, setKey] = useState(props.item.key);

  useEffect(() => {
    if (props.item.key) {
      const stringWithSpaces = props.item.key.replace(/_/g, " ");
      const words = stringWithSpaces.split(" ");

      const formattedWords = words.map((word) => {
        if (word.length === 0) {
          return "";
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });
      setKey(formattedWords.filter((word) => word !== "").join(" "));
    }
  }, [props.item]);

  return (
    <div className={`${styles.Analysis__Container}`}>
      <div className={`${styles.Analysis__Key}`}>
        <h6>{key}</h6>
      </div>
      <div className={`${styles.Analysis__Value}`}>
        <h6>{props.item.value}</h6>
      </div>
      <div className={`${styles.Analysis__Data}`}>
        <div className={`${styles.Analysis__Confidence}`}>
          <h6>
            Confidence:{" "}
            {props.item.confidence
              ? Math.round(props.item.confidence * 100) / 100
              : 0}
          </h6>
        </div>
        <div className={`${styles.Analysis__Page}`}>
          <h6>Page: {props.item.page}</h6>
        </div>
      </div>
    </div>
  );
};

export default Analysis;
